var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bom-tree-chart-list',{ref:"bomTreeChartList",staticClass:"app-container"})
}
var staticRenderFns = []

export { render, staticRenderFns }